var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useLayout } from "@/hooks/layout";
import { useGetModuleFieldDefsQuery, useGetRelationshipWithContactQuery, } from "@/store/api";
import { Slot } from "@/utils/types/layout";
import { faX } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
export default function WidgetRelation(_a) {
    var _b, _c;
    var widget = _a.widget;
    var module = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.moduleName;
    var id = (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.recordId;
    var layout = useLayout();
    var t = useTranslation(["Contacts", "common", "Accounts"]).t;
    // Fetching data with hooks
    var _d = useGetRelationshipWithContactQuery({ module: module, id: id }), response = _d.data, isLoading = _d.isLoading, isError = _d.isError, isFetching = _d.isFetching;
    var view_defs = useGetModuleFieldDefsQuery("Contacts").data;
    // State for records and columns
    var _e = useState([]), records = _e[0], setRecords = _e[1];
    var _f = useState([]), columns = _f[0], setColumns = _f[1];
    useEffect(function () {
        var _a;
        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.results) {
            setRecords(response.data.results);
        }
    }, [response]);
    useEffect(function () {
        var _a;
        if ((_a = view_defs === null || view_defs === void 0 ? void 0 : view_defs.data) === null || _a === void 0 ? void 0 : _a.layout) {
            var filteredLayout = view_defs.data.layout.filter(function (column) { return column.default; });
            setColumns(filteredLayout);
        }
    }, [view_defs]);
    // UseMemo to avoid recalculating the columns and records for each render
    var tableColumns = useMemo(function () { return columns; }, [columns]);
    var tableData = useMemo(function () { return records; }, [records]);
    var handleRemoveWidget = function () {
        layout.removeWidgetById({
            id: widget.id,
            slot: [Slot.DRAWER_EAST],
            type: "widget/search/relation",
        });
    };
    return (_jsx("div", __assign({ className: "max-h-screen overflow-auto w-full text-[var(--colors-label)]" }, { children: _jsxs("div", __assign({ className: "ml-2 rounded-md" }, { children: [_jsx("div", __assign({ className: "flex justify-end" }, { children: _jsx(FontAwesomeIcon, { icon: faX, className: "cursor-pointer m-2 p-2 rounded bg-gray-100", onClick: handleRemoveWidget }) })), _jsxs("div", __assign({ className: "p-5" }, { children: [_jsx("h2", { children: "List contacts en relation:" }), _jsxs("table", __assign({ width: "100%", className: "relative w-full mt-5 bg-white border-collapse border border-gray-200 text-sm" }, { children: [_jsx("thead", __assign({ className: "bg-gray-100" }, { children: _jsx("tr", { children: tableData.length > 0 &&
                                            tableColumns.map(function (column) { return (_jsx("th", __assign({ className: "w-[150px] truncate border-b text-left px-2 py-2 bg-gray-5\"" }, { children: t("LBL_".concat(column.name.toUpperCase()), {
                                                    ns: "Accounts",
                                                }) }), column.name)); }) }) })), _jsx("tbody", { children: tableData.map(function (record) { return (_jsx("tr", __assign({ className: "odd:bg-gray-50 hover:bg-gray-100 transition" }, { children: tableColumns.map(function (column) { return (_jsx("td", __assign({ className: " border-gray-200 px-2 py-1" }, { children: column.name === "name" ? (_jsx("a", __assign({ href: "/modules/Contacts/DetailView/".concat(record.id), className: "text-[var(--colors-link)]" }, { children: record[column.name] }))) : (record[column.name]) }), column.name)); }) }), record.id)); }) })] })), tableData.length <= 0 && (_jsx("div", __assign({ className: "flex-1 py-5 text-md" }, { children: _jsx("span", __assign({ className: "italic " }, { children: "__No result found.__" })) })))] }))] })) })));
}
// Register widget
widgetsDictionary.register("widget/search/relation", {
    name: "Widget Search relation",
    display: WidgetRelation,
    selectable: false,
});
